import { AsterIcon } from "../components/icons/AsterIcon";
import { HyperliquidIcon } from "../components/icons/HyperliquidIcon";
import { OrderlyIcon } from "../components/icons/OrderlyIcon";
import { LayoutGrid, Landmark } from "lucide-react";

export const exchangeGroups = [
  {
    id: "combined",
    label: "Combined",
    icon: LayoutGrid,
    items: [{ label: "Dashboard", to: "/web3/combined" }],
  },
  {
    id: "hyperliquid",
    label: "Hyperliquid",
    icon: HyperliquidIcon,
    items: [
      { label: "Fills", to: "/web3/hyperliquid/fills" },
      { label: "Fees", to: "/web3/hyperliquid/fees" },
    ],
  },
  {
    id: "forex",
    label: "Forex",
    icon: Landmark,
    items: [
      { label: "Withdrawals", to: "/web3/forex/withdrawals" },
      { label: "Deposits", to: "/web3/forex/deposits" },
      { label: "Sweep", to: "/web3/forex/sweep" },
    ],
  },
  {
    id: "orderly",
    label: "Orderly",
    icon: OrderlyIcon,
    comingSoon: true,
    items: [{ label: "Fills", to: "#", disabled: true }],
  },
  {
    id: "aster",
    label: "Aster",
    icon: AsterIcon,
    comingSoon: true,
    items: [{ label: "Fills", to: "#", disabled: true }],
  },
];
